import React, { forwardRef, useState } from "react";
import { ActionIcon, Tooltip } from "@mantine/core";
import { useObjectStore } from "../zustand/objects";
import { storyboardToolbarIconStyles } from "../styleFile";

/** 20px glyph box — keeps MUI icons visually consistent inside the 40px frame */
const glyphWrap = {
  display: "inline-flex",
  width: 20,
  height: 20,
  alignItems: "center",
  justifyContent: "center",
  color: "inherit",
};

const StoryboardToolbarIcon = forwardRef(function StoryboardToolbarIcon(
  { label, onClick, children, tooltip = true, withArrow = true, ...rest },
  ref
) {
  const [hover, setHover] = useState(false);
  const isDarkChrome = useObjectStore((s) => s.viewportThemeOverride === "dark");

  const {
    onPointerOver: onPointerOverProp,
    onPointerLeave: onPointerLeaveProp,
    ...actionRest
  } = rest;

  const actionIcon = (
    <ActionIcon
      ref={ref}
      variant="transparent"
      aria-label={label}
      onPointerOver={(e) => {
        setHover(true);
        onPointerOverProp?.(e);
      }}
      onPointerLeave={(e) => {
        setHover(false);
        onPointerLeaveProp?.(e);
      }}
      onClick={onClick}
      styles={storyboardToolbarIconStyles(hover, isDarkChrome)}
      {...actionRest}
    >
      <span style={glyphWrap}>{children}</span>
    </ActionIcon>
  );

  if (!tooltip) {
    return actionIcon;
  }

  return (
    <Tooltip label={label} position="bottom" withArrow={withArrow} arrowSize={6}>
      {actionIcon}
    </Tooltip>
  );
});

export default StoryboardToolbarIcon;
